const initialState = {
  // Getting Item List
  isGettingItemList: false,
  itemList: [],

  // is Adding Item
  isAddingItemList: false,

  // is Updating Item
  isUpdatingItemList: false,

  // is Deleting Item
  isDeletingItemList: false,

  // is Getting Uom List 
  isGettingUomsList: false,
  uomList: [],
};

const ItemListReducer = (state = initialState, action) => {
  switch (action.type) {
    // Getting Item List
    case "ITEM_LIST_REQUEST":
      return {
        ...state,
        isGettingItemList: true,
      };
    case "ITEM_LIST_SUCCESS":
      return {
        ...state,
        itemList: action.payload?.data,
        page: action.payload?.page,
        totalResults: action.payload?.totalResults,
        isGettingItemList: false,
      };
    case "ITEM_LIST_ERROR":
      return {
        ...state,
        isGettingItemList: false,
      };
    // Editing Item List
    case "ADD_ITEM_REQUEST":
      return {
        ...state,
        isAddingItemList: true,
      };
    case "ADD_ITEM_SUCCESS":
      return {
        ...state,
        isAddingItemList: false,
      };
    case "ADD_ITEM_ERROR":
      return {
        ...state,
        isAddingItemList: false,
      };
    // Updateing Item List
    case "UPDATE_ITEM_LIST_REQUEST":
      return {
        ...state,
        isUpdatingItemList: true,
      };
    case "UPDATE_ITEM_LIST_SUCCESS":
      return {
        ...state,
        isUpdatingItemList: false,
      };
    case "UPDATE_ITEM_LIST_ERROR":
      return {
        ...state,
        isUpdatingItemList: false,
      };
    // Deleting Item List
    case "DELETE_ITEM_LIST_REQUEST":
      return {
        ...state,
        isDeletingItemList: true,
      };
    case "DELETE_ITEM_LIST_SUCCESS":
      return {
        ...state,
        isDeletingItemList: false,
      };
    case "DELETE_ITEM_LIST_ERROR":
      return {
        ...state,
        isDeletingItemList: false,
      };
    // Getting Uoms
    case "UOM_LIST_REQUEST":
      return {
        ...state,
        isGettingUomsList: true,
      };
    case "UOM_LIST_SUCCESS":
      return {
        ...state,
        uomList: action.payload?.data,
        isGettingUomsList: false,
      };
    case "UOM_LIST_ERROR":
      return {
        ...state,
        isGettingUomsList: false,
      };
    default:
      return state;
  }
};

export default ItemListReducer;
